import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ImageGridService from './ImageGridService';

// Get user from
const initialState = {
  getImageGrid: '',
  getImageGridError: false,
  getImageGridSuccess: false,
  ImageGridLoading: false,
  getImageGridErrorMsg: '',
};

// getting____________PaymentStripe____________________
export const gettingImageGrid = createAsyncThunk(
  'getImageGrid/gettingImageGrid',

  async (data, thunkAPI) => {
    try {
      const response = await ImageGridService.gettingImageGrid(data); 
      
      return response; 
      // getting getlink data from getlink services
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const getImageGridErrorMsg =
        (error.response && error.response.data && error.response.data.getImageGridErrorMsg) || error.getBioLinkErrorMsg || error.toString();

      return thunkAPI.rejectWithValue(getImageGridErrorMsg);
    }
  }
);

export const ImageGridSlice = createSlice({
    name: 'imageGrid',
    initialState,
    reducers: {
      
      reset: (state) => {
        state.getImageGrid=[];
        state.getImageGridError= false;
        state.getImageGridSuccess= false;
        state.ImageGridLoading= false;
        state.getImageGridErrorMsg= '';
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(gettingImageGrid.pending, (state) => {
          state.ImageGridLoading = true;
        })
        .addCase(gettingImageGrid.fulfilled, (state, action) => {
          state.ImageGridLoading = false;
          state.getImageGridSuccess = true;
          state.getImageGrid = action.payload;
        })
        .addCase(gettingImageGrid.rejected, (state, action) => {
          state.ImageGridLoading = false;
          state.getImageGridError = true;
          state.getImageGridErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
        });
    },
  });

  export const griImgList = (state) => state.imageGrid;
  export const { reset } = ImageGridSlice.actions;

export default ImageGridSlice.reducer;